import Router from "next/router";
import WholePageLoadingBlankslate from "../../components/shared/WholePageLoadingBlankslate";
import ServerResponseContext from "./ServerResponseContext";

interface IRedirectProps {
  to: string;
  httpStatus?: 301 | 302 | 303 | number;
}

function Redirect({ to, httpStatus = 302 }: IRedirectProps) {
  return (
    <ServerResponseContext.Consumer>
      {(response) => {
        if (response) {
          response.writeHead(httpStatus, {
            Location: to,
          });

          response.end();

          return null;
        }

        if (typeof window !== "undefined") {
          Router.replace(to);
          return <WholePageLoadingBlankslate />;
        }

        return null;
      }}
    </ServerResponseContext.Consumer>
  );
}

export default Redirect;
